import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Kuzzle } from 'kuzzle-sdk';
import { ALERT_HISTORY_COLLECTION } from '@/helpers/alertRules';
import debounce from 'lodash/debounce';
@Module({ namespaced: true })
export default class Alerts extends VuexModule {
  pending: number = 0;

  /**
   * Holds the ID of the subscription to the "alerts" collection.
   *
   * @see subscribeToNewAlerts
   */
  subscriptionId: string | null = null;

  get hasPending(): Boolean {
    return this.pending > 0;
  }

  get pendingAlerts(): number {
    return this.pending;
  }

  @Mutation
  SET_PENDING(value: number) {
    this.pending = value;
  }

  @Mutation
  DECREMENT_PENDING() {
    this.pending--;
  }

  @Mutation
  SET_SUBSCRIPTION_ID(value: string) {
    this.subscriptionId = value;
  }

  @Action
  async UNSUBSCRIBE(kuzzle: Kuzzle) {
    if (!this.subscriptionId) {
      return;
    }

    await kuzzle.realtime.unsubscribe(this.subscriptionId);
    this.context.commit('SET_SUBSCRIPTION_ID', null);
  }

  @Action
  async SUBSCRIBE_TO_NEW_ALERTS({
    indexName,
    kuzzle,
    log
  }: {
    indexName: string;
    kuzzle: Kuzzle;
    log: any;
  }) {
    if (this.subscriptionId) {
      try {
        await this.context.dispatch('UNSUBSCRIBE');
      } catch (error) {
        // Ingore unsubscribe errors
      }
    }
    const roomId = await kuzzle.realtime.subscribe(
      indexName,
      ALERT_HISTORY_COLLECTION,
      {
        equals: {
          status: 'pending'
        }
      },
      debounce(
        () => {
          try {
            this.context.dispatch('FETCH_PENDING_ALERTS_COUNT', {
              indexName,
              kuzzle
            });
          } catch (error) {
            log.warn(
              `(subscription) Something went wrong while fetching the alerts count: ${error}`
            );
          }
        },
        1300 // Since the action performs a search, we need to let ES perform the indexation
      )
    );
    this.context.commit('SET_SUBSCRIPTION_ID', roomId);
  }

  @Action
  async FETCH_PENDING_ALERTS_COUNT({
    indexName,
    kuzzle,
    log
  }: {
    indexName: string;
    kuzzle: Kuzzle;
    log: any;
  }) {
    // if (
    //   !(await kuzzle.collection.exists(indexName, ALERT_HISTORY_COLLECTION))
    // ) {
    //   return;
    // }
    try {
      const response = await kuzzle.document.search(
        indexName,
        ALERT_HISTORY_COLLECTION,
        {
          query: {
            term: {
              status: 'pending'
            }
          }
        },
        {
          size: 0
        }
      );
      this.context.commit('SET_PENDING', response.total);
    } catch (error) {
      log.warn(
        `Something went wrong while fetching the alerts count: ${error}`
      );
    }
  }
}
